<template>
  <div class="view-forum">
    <action-dispatcher
      action="community/getForum"
      :parameters="$route.params.forumId"
    >
      <template #default="{ data: forum }">
        <div class="forum-header">
          <div class="container-fluid">
            <div class="header-content d-flex align-items-center">
              <button class="btn btn-back p-0 mr-3" @click="goBack">
                <i class="icon-chevron-left" />
              </button>
              <div class="flex-fill">
                <h4 class="forum-name mb-0">{{ forum.name }}</h4>
                <p v-if="forum.description" class="forum-description mb-0">
                  {{ forum.description }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid forum-body">
          <post-composer
            v-if="!forum.is_archived"
            :community-id="$route.params.id"
            :forum-id="$route.params.forumId"
            @created="onPostCreated"
          />
          <p v-else class="forum-archived mb-0">
            Este fórum foi arquivado. Não é possível publicar.
          </p>

          <community-feed
            ref="feed"
            :community-id="$route.params.id"
            :forum-id="$route.params.forumId"
            class="mt-4"
          />
        </div>
      </template>
    </action-dispatcher>
  </div>
</template>

<script>
import PostComposer from "@/components/community/PostComposer.vue";
import CommunityFeed from "@/components/community/CommunityFeed.vue";

export default {
  name: "ForumView",
  components: { PostComposer, CommunityFeed },
  methods: {
    goBack() {
      this.$router.push({
        name: "community",
        params: { id: this.$route.params.id }
      });
    },
    onPostCreated() {
      if (this.$refs.feed) this.$refs.feed.reload();
    }
  }
};
</script>

<style lang="scss" scoped>
.view-forum {
  padding-top: 72px;
  padding-bottom: 40px;

  .forum-header {
    margin-bottom: 24px;

    .btn-back {
      border: none;
      background: transparent;
      color: inherit;

      i {
        font-size: 22px;
      }
    }

    .forum-name {
      font-size: 20px;
      font-weight: 600;
    }

    .forum-description {
      font-size: 14px;
      opacity: 0.75;
      overflow-wrap: anywhere;
    }
  }

  .forum-archived {
    padding: 16px;
    border-radius: 12px;
    border: 1px solid rgba(255, 179, 71, 0.4);
    background: rgba(255, 179, 71, 0.12);
    font-size: 14px;
  }
}
</style>
